import React, { useState, useEffect } from 'react';
import MainContent from './layout/MainContent';
import BigCalendar from './utilities/BigCalendar'

//Función principal
const Agenda = () => {
	
	//Renderizo
	return (
		<MainContent 
		title='Agenda' 
		subtitle='Listado' 
		// nodes={nodes}
		// actions={actions}
		component={BigCalendar} />
		)
	};
	
export default Agenda;